export default "__VITE_ASSET__ByGdxQ75__"